import React from "react";
import {Button, Card, Col, Row} from "antd";
import {InnerTabs, MyBreadcrumb, MyText} from "../../components";
import {StyledCollapse} from "./index.styles";
import {FaqIcon} from "../../assets";


export const Help = () => {
  const collapseItems = [
    {
      key: '1',
      label: (
        <MyText size={16} weight={400}>
          С чего начать при работе с системой «Білімал.Электронды колледж»?
        </MyText>
      ),
      children: <p>Ваша заявка №135 от 02.09.2023 года решена, пожалуйста, проверьте в системе.</p>,
    },
    {
      key: '2',
      label: (
        <MyText size={16} weight={400}>
          С чего начать при работе с системой «Білімал.Электронды колледж»?
        </MyText>
      ),
      children: <p>Ваша заявка №135 от 02.09.2023 года решена, пожалуйста, проверьте в системе.</p>,
    },
  ]

  const tabsItems = [
    {
      key: '1',
      label: 'Пошаговое руководство пользователя',
      children: (
        <Row style={{padding: 16}} gutter={[16, 32]}>
          <Col span={24}>
            <Row align='middle' justify='space-between'>
              <Col>
                <MyText size={24} weight={500}>
                  Руководство пользователя по модулю
                </MyText>
              </Col>

              <Col>
                <Button>
                  Скачать Руководство
                </Button>
              </Col>
            </Row>
          </Col>

          <Col span={24}>
            <Card title={(
              <Row align='middle' gutter={16}>
                <Col>
                  <FaqIcon width={24} height={24}/>
                </Col>

                <Col>
                  <MyText size={18} weight={500}>
                    Часто задаваемые вопросы
                  </MyText>
                </Col>
              </Row>
            )} bodyStyle={{padding: 0}} headStyle={{backgroundColor: 'var(--c-table-header)'}}>
              <StyledCollapse items={collapseItems}/>
            </Card>
          </Col>
        </Row>
      ),
    },
    {
      key: '2',
      label: 'Управление организацией',
      children: '',
    },
    {
      key: '3',
      label: 'Учебный процесс',
      children: '',
    }
  ]
  return (
    <>
      <MyBreadcrumb title="База знаний"/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <InnerTabs items={tabsItems}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}